export const Base_Url = "https://hosthelperapp.com:4000/";

export function getToken() {
  return sessionStorage.getItem("token");
}
export const formattedDateFn = (createdAt) => {
  const date = new Date(createdAt);
  const formattedDate = date.toLocaleDateString("en-US");
  return formattedDate;
};

export const User_Management_Table_Head = [
  {
    _id: "No",
    numeric: true,
    disablePadding: false,
    label: "No.",
  },
  {
    _id: "name",
    numeric: false,
    disablePadding: true,
    label: "Name",
  },
  {
    _id: "email",
    numeric: false,
    disablePadding: true,
    label: "Email address",
  },
  {
    _id: "phoneNumber",
    numeric: true,
    disablePadding: false,
    label: "Mobile number",
  },
  {
    _id: "cleanerCount",
    numeric: true,
    disablePadding: false,
    label: "Cleanear Invited",
  },
  {
    _id: "subscription",
    numeric: true,
    disablePadding: false,
    label: "Subscription",
  },
  {
    _id: "createdAt",
    numeric: true,
    disablePadding: false,
    label: "Joining date",
  },
  {
    _id: "row",
    numeric: true,
    disablePadding: false,
    label: "Action",
  },
];

export const Cleaner_Management_Table_Head = [
  {
    _id: "No",
    numeric: true,
    disablePadding: false,
    label: "No.",
  },
  {
    _id: "name",
    numeric: false,
    disablePadding: true,
    label: "Name",
  },
  {
    _id: "email",
    numeric: false,
    disablePadding: true,
    label: "Email address",
  },
  {
    _id: "phoneNumber",
    numeric: true,
    disablePadding: false,
    label: "Mobile number",
  },

  {
    _id: "companyName",
    numeric: true,
    disablePadding: false,
    label: "Company’s name",
  },
  {
    _id: "cleanings",
    numeric: true,
    disablePadding: false,
    label: "Cleanings",
  },
  {
    _id: "invitedBy",
    numeric: true,
    disablePadding: false,
    label: "Invited By",
  },
  {
    _id: "createdAt",
    numeric: true,
    disablePadding: false,
    label: "Joining date",
  },
  {
    _id: "row",
    numeric: true,
    disablePadding: false,
    label: "Action",
  },
];

export const Property_Management_Table_Head = [
  {
    _id: "No",
    numeric: true,
    disablePadding: false,
    label: "No.",
  },
  {
    _id: "name",
    numeric: false,
    disablePadding: true,
    label: "Name",
  },
  {
    _id: "type",
    numeric: false,
    disablePadding: true,
    label: "Type",
  },
  {
    _id: "address",
    numeric: true,
    disablePadding: false,
    label: "Address",
  },

  {
    _id: "city",
    numeric: true,
    disablePadding: false,
    label: "City",
  },
  {
    _id: "state",
    numeric: true,
    disablePadding: false,
    label: "State",
  },
  {
    _id: "createdAt",
    numeric: true,
    disablePadding: false,
    label: "Listing date",
  },
  {
    _id: "managedBy",
    numeric: true,
    disablePadding: false,
    label: " Managed by",
  },
  {
    _id: "row",
    numeric: true,
    disablePadding: false,
    label: "Action",
  },
];

export const Subscription_Management_Table_Head = [
  {
    _id: "No",
    numeric: true,
    disablePadding: false,
    label: "No.",
  },
  {
    _id: "userName",
    numeric: false,
    disablePadding: true,
    label: "Name",
  },
  {
    _id: "email",
    numeric: false,
    disablePadding: true,
    label: "Subscription",
  },
  {
    _id: "durationMonths",
    numeric: true,
    disablePadding: false,
    label: "Duration",
  },
  {
    _id: "price",
    numeric: true,
    disablePadding: false,
    label: "Price",
  },
  {
    _id: "createdAt",
    numeric: true,
    disablePadding: false,
    label: "Start date",
  },
  {
    _id: "endDate",
    numeric: true,
    disablePadding: false,
    label: "End date",
  },
  // {   if We Used Action in table then We Used To unCommiot
  //   _id: "row",
  //   numeric: true,
  //   disablePadding: false,
  //   label: "Action",
  // },
];
